"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class TealiumLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(baseScriptUrl) {
        super('Tealium', constants_1.LOAD_CONFIG);
        this.baseScriptUrl = baseScriptUrl;
    }
    preload() {
        window.utag_cfg_ovrd = constants_1.UTAG_CFG_OVRD;
    }
    getUrls() {
        return [this.baseScriptUrl + constants_1.URL_UTAG_SYNC, this.baseScriptUrl + constants_1.URL_UTAG];
    }
}
exports.TealiumLoader = TealiumLoader;
//# sourceMappingURL=index.js.map